const rankingItems = [
  { id: 1, title: '星际远征：黑暗宇宙', hot: '986.5万', tag: '香蕉视频', change: 'up' },
  { id: 2, title: '真相迷宫', hot: '872.3万', tag: '红桃视频', change: 'up' },
  { id: 3, title: '欢乐喜剧人·巅峰之战', hot: '765.8万', tag: '蜜桃视频', change: 'up' },
  { id: 4, title: '深海危机', hot: '698.2万', tag: '91视频', change: 'down' },
  { id: 5, title: '九州缥缈录·续', hot: '621.4万', tag: '香蕉视频', change: 'up' },
  { id: 6, title: '极限挑战·冒险季', hot: '587.9万', tag: '红桃视频', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">热播榜单</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">实时热度排行，看看大家都在追什么</p>
        </div>

        <div className="max-w-[800px] mx-auto bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, index) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 px-5 md:px-6 py-4 hover:bg-background-100 transition-colors cursor-pointer ${index !== rankingItems.length - 1 ? 'border-b border-background-200/60' : ''}`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'} text-sm font-bold`}>
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 truncate">{item.title}</h3>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-400">{item.tag}</span>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-medium text-accent-600 whitespace-nowrap">{item.hot}</span>
                <span className={`w-5 h-5 flex items-center justify-center ${item.change === 'up' ? 'text-primary-500' : item.change === 'new' ? 'text-secondary-500' : 'text-foreground-400'}`}>
                  {item.change === 'up' ? <i className="ri-arrow-up-fill text-sm"></i> : item.change === 'down' ? <i className="ri-arrow-down-fill text-sm"></i> : <i className="ri-sparkling-fill text-sm"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}